module.exports = __webpack_public_path__ + "static/media/about_me.df9c0f18.png";